export default function jsonParse(jsonString?: string) {
  return jsonString ? JSON.parse(jsonString) : null;
}
